import { useMemo } from "react";
import useProcessedCallsState from "./useProcessedCallsState";
import {
  ArrowPathIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/outline";
import ProcessedCallsByStatus from "./ProcessedCallsByStatus";
import { Button } from "V2.0/common/button";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { formatTime } from "V2.0/utils";
import InputComponent from "V2.0/components/InputComponent";
import { QUEUED_AT } from "./constants";

export default function ProcessedCallsStats(props) {
  const { workspaceId, assistantId } = props;

  const { state, updateQueuedAt } = useProcessedCallsState(
    workspaceId,
    assistantId
  );

  const QueuedCalls = useMemo(
    function () {
      if (state.isLoading) {
        return (
          <div className="flex items-center justify-center min-h-40">
            <AiOutlineLoading3Quarters className="animate-spin" />
          </div>
        );
      }

      if (!state.completedCalls && !state.failedCalls && !state.pendingCalls) {
        return (
          <div className="flex items-center justify-center min-h-40 gap-x-2 text-gray-500">
            <InformationCircleIcon className="size-4" />
            <p className="text-sm">No data</p>
          </div>
        );
      }

      return (
        <ProcessedCallsByStatus
          pendingCalls={state.pendingCalls}
          completedCalls={state.completedCalls}
          failedCalls={state.failedCalls}
        />
      );
    },
    [
      state.isLoading,
      state.pendingCalls,
      state.completedCalls,
      state.failedCalls,
    ]
  );

  return (
    <div className="flex flex-col border rounded-lg">
      <div className="flex flex-col bg-gray-50 rounded-t-lg px-4 py-2">
        <div className="flex items-center gap-x-2">
          <p className="text-base font-semibold">{`Processed Calls (${state.totalCalls})`}</p>
          <Button
            onClick={() => updateQueuedAt(state.queuedAt)}
            plain
          >
            <ArrowPathIcon />
          </Button>
        </div>
        <div>
          <p className="text-xs">
            Last Updated at: {formatTime(state.lastUpdatedAt)}
          </p>
        </div>
      </div>
      <div className="px-4 w-3/4">
        <InputComponent
          type="select"
          value={state.queuedAt}
          onChange={(e) => updateQueuedAt(e.target.value)}
          options={Object.values(QUEUED_AT).map(function (option, idx) {
            return {
              id: idx,
              value: option,
              label: `Last ${option}`,
            };
          })}
        />
      </div>
      <div className="px-4 pb-2">{QueuedCalls}</div>
    </div>
  );
}
